import { SatelliteViewModel } from '@/app/proxy/proxies';
import { SharedModule } from '@/app/shared/shared.module';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-analysis',
  imports: [SharedModule],
  templateUrl: './no-analysis.component.html',
  styleUrl: './no-analysis.component.less',
})
export class NoAnalysisComponent {
  @Input() selectedDay: SatelliteViewModel;
  @Input() isPreparing: boolean;
}
